import { getKeyByValue } from './object';
import { agentProductionTerms as apt, TimePeriods } from '../../constants';

export const removeDuplicates = (arr) => {
    return arr.filter((item, index) => {
        return index === arr.findIndex(obj => JSON.stringify(obj) === JSON.stringify(item));
    });
};

export const msToDays = (ms) => ms / (1000 * 60 * 60 * 24);

export const filterItemByKeyfieldValue = (list, keyfield, keyfieldValueToRemove) => {
    return list.filter(item => item[keyfield] !== keyfieldValueToRemove);
};

export const getCriteriaObject = (searchCriteria) => searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters?.[0];

export const searchForKeyfieldInProperties = (obj, keyfieldToUpdate, valueToUpdate) => {
    for (let key in obj) {
        if (key === keyfieldToUpdate) {
            obj[keyfieldToUpdate] = valueToUpdate;
            return;
        }
        if (Array.isArray(obj[key])) {
            obj[key].forEach((nestedObj) => {
                if (typeof obj[key] === 'object' && obj[key] !== undefined) {
                    searchForKeyfieldInProperties(nestedObj, keyfieldToUpdate, valueToUpdate);
                }
            });
        }
        if (typeof obj[key] === 'object' && obj[key] !== undefined) {
            searchForKeyfieldInProperties(obj[key], keyfieldToUpdate, valueToUpdate);
        }
    }
};

export const getUpdatedObjectByKeyfield = (object, keyfieldToUpdate, valueToUpdate) => {
    const parsedObject = JSON.parse(JSON.stringify(object));
    searchForKeyfieldInProperties(parsedObject, keyfieldToUpdate, valueToUpdate);
    return parsedObject;
};

export const reverseMap = (mapObject) => {
    return Object.fromEntries(
        Object.entries(mapObject).map(([key, value]) => [value, key])
    );
};

export const getPercentChange = (valueA, valueB) => {
    return (valueA / valueB) * 100;
};

export const buildSearchCriteria = ({
    currentTabId,
    mlsId,
    propertyTypeIds,
    propertyTypeNames,
    agentIds,
    listId,
    officeIds,
    searchAllMLS=true,
    timePeriod,
}) => {
    const idFiltering = (agentIds && listId)
        ? [{
            idType: 'agentId',
            idValues: agentIds,
            listId: listId
        }]
        : [];
    const timePeriodCriteria = typeof timePeriod === 'string' ? { intervalType: timePeriod } : timePeriod;
    return {
        criteria: {
          realEstateDatasourceIdsWithFilters: [
            {
              realEstateDatasourceId: mlsId,
              ...(currentTabId === 'coopAgents' && officeIds && officeIds.length
                ? {
                    idFiltering: [
                        {
                            "idType": "officeId",
                            "idValues": officeIds
                        }
                    ]
                }
                : {
                    searchFields: [
                        {
                          fieldName: "propertyType",
                          fieldValues: propertyTypeIds || [],
                          fieldValueDescriptions: propertyTypeNames || []
                        }
                    ],
                    searchAllMLS,
                    computedFields: [],
                    idFiltering,
                })
            }],
            timePeriod: {
                intervalType: timePeriodCriteria.intervalType,
                startDate: timePeriodCriteria.startDate || null,
                endDate: timePeriodCriteria.endDate || null,
            }
        },
        offset: 0,
        size: 0,
    }
};

export const getCurrentSearchDates = (timeIntervals, selectedTimePeriod) => {
    if (!timeIntervals?.length) return;
    const interval = timeIntervals?.find((i) => i?.intervalType === selectedTimePeriod);
    if (!interval) return;
    const lastIntervalText = getKeyByValue(TimePeriods, selectedTimePeriod);
    const from = new Date(`${interval.last.from}Z`);
    const to = new Date(`${interval.last.to}Z`);
    return { lastIntervalText, from, to };
};

export const getCurrentTabTimePeriod = (tabProducersState) => (
    tabProducersState?.newProd?.value
        || tabProducersState?.timeFrame?.value
        || tabProducersState?.timePeriod?.value
        || apt.annually
);
